import React from 'react';
import type {
  IndexInstrumentViewModel,
  IndicesCountryViewModel,
  IndicesPeriod,
} from '@app-types/indices';
import CountryHeader from './CountryHeader';
import IndexCard from './IndexCard';

interface IndicesCountrySectionProps {
  country: IndicesCountryViewModel;
  grid: 'us-wide' | 'standard' | 'singleton';
  period: IndicesPeriod;
  onSelectInstrument: (instrument: IndexInstrumentViewModel, trigger: HTMLElement) => void;
}

const IndicesCountrySection: React.FC<IndicesCountrySectionProps> = ({
  country,
  grid,
  period,
  onSelectInstrument,
}) => (
  <section
    className="indices-country-section"
    aria-label={country.countryLabel}
  >
    <CountryHeader country={country.country} countryLabel={country.countryLabel} />
    <div
      className={'indices-card-grid indices-card-grid--' + grid}
      data-country-grid={country.country}
    >
      {country.instruments.map((instrument) => (
        <IndexCard
          key={instrument.id}
          instrument={instrument}
          period={period}
          onSelect={onSelectInstrument}
        />
      ))}
    </div>
  </section>
);

export default IndicesCountrySection;
